<template>
  <div class="my-register-page mb-5">
    <div class="my-container">
      <b-row class="mb-2 mt-3 pt-3 align-items-center">
        <b-col>
          <h1>{{ $t("Request") }}</h1>
        </b-col>
        <b-col v-if="IsEmployee" cols="auto" class="text-right">
          <!-- Устунлар бошқаруви — BO'даги каби -->
          <b-dropdown
            right
            size="sm"
            variant="primary"
            menu-class="rq-columns-menu"
          >
            <template #button-content>
              <b-icon icon="gear-fill" class="mr-1"></b-icon>
              {{ $t("Columns") }}
            </template>
            <b-dropdown-header>{{ $t("ManageColumns") }}</b-dropdown-header>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="ShowAllColumns">
              <b-icon icon="check2-square" class="mr-2"></b-icon>
              {{ $t("ShowAllColumns") }}
            </b-dropdown-item>
            <b-dropdown-item @click="HideAllColumns">
              <b-icon icon="square" class="mr-2"></b-icon>
              {{ $t("HideAllColumns") }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-for="field in Fields"
              :key="field.key"
              @click.native.capture.stop.prevent="ToggleColumn(field.key)"
            >
              <b-icon
                v-if="VisibleColumns[field.key]"
                icon="check2-square"
                class="mr-2"
                style="color: #28a745"
              ></b-icon>
              <b-icon v-else icon="square" class="mr-2"></b-icon>
              <span>{{ field.label }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>

      <!-- Ходим (isEmployee) учун BO'даги "Текширувни рўйхатга олиш" жадвали -->
      <b-table-simple v-if="IsEmployee" bordered responsive class="rq-table">
        <b-thead class="text-center">
          <b-tr variant="primary">
            <b-th
              v-for="field in VisibleFields"
              :key="field.key"
              style="vertical-align: middle"
            >
              {{ field.label }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <!-- Ҳар бир устун бўйича филтр -->
          <b-tr class="rq-filter-row">
            <b-td
              v-for="field in VisibleFields"
              :key="field.key"
              style="vertical-align: middle"
            >
              <template v-if="field.key === 'actions'">
                <div class="rq-filter-actions">
                  <b-button
                    variant="primary"
                    size="sm"
                    v-b-tooltip.hover
                    :title="$t('Search')"
                    @click="Search"
                  >
                    <b-icon icon="search"></b-icon>
                  </b-button>
                  <b-button
                    variant="outline-secondary"
                    size="sm"
                    v-b-tooltip.hover
                    :title="$t('ClearFilter')"
                    @click="ClearFilters"
                  >
                    <b-icon icon="x"></b-icon>
                  </b-button>
                </div>
              </template>
              <b-form-input
                v-else-if="field.filter === 'date'"
                type="date"
                size="sm"
                v-model="filter.filters[field.key].value"
                @change="Search"
              ></b-form-input>
              <b-form-input
                v-else-if="field.filter === 'text'"
                size="sm"
                v-model="filter.filters[field.key].value"
                :placeholder="field.label"
                @keyup.enter="Search"
              ></b-form-input>
            </b-td>
          </b-tr>
          <b-tr v-for="(item, index) in Requests" :key="index">
            <b-td
              v-for="field in VisibleFields"
              :key="field.key"
              :class="field.nowrap ? 'text-nowrap' : ''"
              :style="
                field.center
                  ? 'vertical-align: middle; text-align: center'
                  : 'vertical-align: middle'
              "
            >
              <template v-if="field.key === 'idNomer'">
                {{ (filter.page - 1) * filter.pageSize + index + 1 }}
              </template>
              <template v-else-if="field.key === 'actions'">
                <b-link
                  class="rq-view-btn"
                  v-b-tooltip.hover
                  :title="$t('view')"
                  @click="Get(item)"
                >
                  <b-icon icon="eye" font-scale="1.2"></b-icon>
                </b-link>
              </template>
              <template v-else-if="field.key === 'status'">
                <b-badge
                  v-if="StatusText(item)"
                  :class="['rq-badge', 'text-bg-' + StatusVariant(item)]"
                >
                  {{ StatusText(item) }}
                </b-badge>
              </template>
              <template v-else-if="field.key === 'executedStatus'">
                <b-badge
                  v-if="item.executedStatus"
                  :class="['rq-badge', 'text-bg-' + StatusVariant(item)]"
                >
                  {{ item.executedStatus }}
                </b-badge>
              </template>
              <template v-else>
                {{ item[field.key] }}
              </template>
            </b-td>
          </b-tr>
          <b-tr v-if="!Requests.length">
            <b-td :colspan="VisibleFields.length" class="text-center text-muted">
              {{ $t("noData") }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <!-- Тадбиркор учун эски кўриниш -->
      <b-table-simple v-else bordered>
        <b-thead class="text-center">
          <b-tr variant="primary">
            <b-th style="vertical-align: middle">
              {{ $t("docNumber") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("checkDate") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("checkCoverageDate") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("orderedOrganization") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("inspectionOrganization") }}
            </b-th>
            <b-th style="vertical-align: middle">
              {{ $t("actions") }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="(item, index) in Requests" :key="index">
            <b-td class="text-nowrap" style="vertical-align: middle">
              {{ item.docNumber }}
            </b-td>
            <b-td style="white-space:nowrap">
              {{ item.checkStartDate }} - {{ item.checkEndDate }} ({{
                item.checkDaysNumber
              }}
              {{ $t("day") }} )
            </b-td>
            <b-td style="white-space:nowrap">
              {{ item.checkCoverageStartDate }} -
              {{ item.checkCoverageEndDate }}
            </b-td>
            <b-td>
              {{ item.orderedOrganization }}
            </b-td>
            <b-td>
              {{ item.inspectionOrganization }}
            </b-td>
            <b-td style="vertical-align: middle; text-align: center">
              <b-icon
                v-b-tooltip.hover
                :title="$t('Complaint')"
                style="cursor: pointer; margin-right: 10px"
                @click="GetComplaint(item)"
                icon="exclamation-circle-fill"
                size="20"
              ></b-icon>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div>
        <b-pagination
          v-model="filter.page"
          :total-rows="filter.totalRows"
          :per-page="filter.pageSize"
          first-number
          last-number
          @input="Refresh"
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <b-icon icon="chevron-double-left" size="18" />
          </template>
          <template #next-text>
            <b-icon icon="chevron-double-right" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import RequestService from "@/services/request.service";
import customSelect from "../../../components/elements/customSelect.vue";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BBadge,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BIcon,
  BIconEyeFill,
  BLink,
  BDropdown,
  BDropdownItem,
  BDropdownHeader,
  BDropdownDivider,
  BPagination,
  BFormInput,
} from "bootstrap-vue";

// Ҳар доим кўринадиган устунлар
const AlwaysVisibleColumns = ["idNomer", "actions"];

// Ҳар бир устун бўйича филтр — key'лар Fields'даги key'лар билан бир хил
const ColumnMatchModes = {
  status: "contains",
  executedStatus: "contains",
  contractorInn: "contains",
  contractor: "contains",
  docNumber: "contains",
  docDate: "equals",
  orderedOrganization: "contains",
  inspectionOrganization: "contains",
  authorizedOrganization: "contains",
  region: "contains",
  checkType: "contains",
};

function BuildFilters() {
  var filters = {};
  Object.keys(ColumnMatchModes).forEach((key) => {
    filters[key] = { value: "", matchmode: ColumnMatchModes[key] };
  });
  return filters;
}

// BO'даги Color.status билан бир хил ранглар
const StatusVariants = {
  1: "info",
  2: "secondary",
  3: "secondary",
  4: "warning",
  5: "warning",
  6: "danger",
  7: "success",
  8: "danger",
  9: "danger",
  12: "info",
  15: "danger",
};

export default {
  data() {
    return {
      Requests: [],
      VisibleColumns: {},
      filter: {
        page: 1,
        pageSize: 10,
        totalRows: 1,
        filters: BuildFilters(),
        options: [
          {
            value: 10,
            text: "10",
          },
          {
            value: 20,
            text: "20",
          },
          {
            value: 50,
            text: "50",
          },
          {
            value: 100,
            text: "100",
          },
        ],
      },
    };
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BBadge,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTableSimple,
    BIcon,
    BIconEyeFill,
    BLink,
    BDropdown,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
    BPagination,
    BFormInput,
    customSelect,
  },
  created() {
    this.LoadColumns();
    this.Refresh();
  },
  computed: {
    UserInfo() {
      return localStorage.getItem("user_info")
        ? JSON.parse(localStorage.getItem("user_info"))
        : {};
    },
    IsEmployee() {
      return !!this.UserInfo.isEmployee;
    },
    // BO'даги fields билан бир хил тартиб
    Fields() {
      return [
        { key: "idNomer", label: "№", nowrap: true },
        { key: "actions", label: this.$t("actions"), center: true },
        {
          key: "status",
          label: this.$t("state"),
          center: true,
          filter: "text",
        },
        {
          key: "executedStatus",
          label: this.$t("actionResult"),
          center: true,
          filter: "text",
        },
        {
          key: "contractorInn",
          label: this.$t("inn"),
          nowrap: true,
          filter: "text",
        },
        { key: "contractor", label: this.$t("contractor"), filter: "text" },
        {
          key: "docNumber",
          label: this.$t("docNumber"),
          nowrap: true,
          filter: "text",
        },
        {
          key: "docDate",
          label: this.$t("docDate"),
          nowrap: true,
          filter: "date",
        },
        {
          key: "orderedOrganization",
          label: this.$t("orderedOrganization"),
          filter: "text",
        },
        {
          key: "inspectionOrganization",
          label: this.$t("inspectionOrganization"),
          filter: "text",
        },
        {
          key: "authorizedOrganization",
          label: this.$t("authorizedOrganization"),
          filter: "text",
        },
        { key: "region", label: this.$t("oblast"), filter: "text" },
        { key: "checkType", label: this.$t("checkType"), filter: "text" },
      ];
    },
    VisibleFields() {
      return this.Fields.filter((field) => this.VisibleColumns[field.key]);
    },
  },
  methods: {
    ColumnsStorageKey() {
      return "table_columns_" + window.location.pathname;
    },
    LoadColumns() {
      var defaults = {};
      this.Fields.forEach((field) => {
        defaults[field.key] = true;
      });
      var saved = localStorage.getItem(this.ColumnsStorageKey());
      if (saved) {
        try {
          // Сақланганини default билан бирлаштирамиз — янги устунлар ҳам кўринади
          defaults = Object.assign(defaults, JSON.parse(saved));
        } catch (e) {
          localStorage.removeItem(this.ColumnsStorageKey());
        }
      }
      AlwaysVisibleColumns.forEach((key) => {
        defaults[key] = true;
      });
      this.VisibleColumns = defaults;
    },
    SaveColumns() {
      localStorage.setItem(
        this.ColumnsStorageKey(),
        JSON.stringify(this.VisibleColumns)
      );
    },
    ToggleColumn(key) {
      if (AlwaysVisibleColumns.indexOf(key) !== -1) return;
      this.$set(this.VisibleColumns, key, !this.VisibleColumns[key]);
      this.SaveColumns();
      // Устун беркитилса, унинг филтри ҳам тозаланади
      if (!this.VisibleColumns[key] && this.ResetFilter(key)) {
        this.Search();
      }
    },
    // Филтр қийматини тозалайди, ўзгарган бўлса true қайтаради
    ResetFilter(key) {
      var item = this.filter.filters[key];
      if (!item || item.value === "" || item.value == null) return false;
      item.value = "";
      return true;
    },
    Search() {
      this.filter.page = 1;
      this.Refresh();
    },
    ClearFilters() {
      Object.keys(this.filter.filters).forEach((key) => {
        this.filter.filters[key].value = "";
      });
      this.Search();
    },
    ShowAllColumns() {
      this.Fields.forEach((field) => {
        this.$set(this.VisibleColumns, field.key, true);
      });
      this.SaveColumns();
    },
    HideAllColumns() {
      var changed = false;
      this.Fields.forEach((field) => {
        this.$set(
          this.VisibleColumns,
          field.key,
          AlwaysVisibleColumns.indexOf(field.key) !== -1
        );
        if (this.ResetFilter(field.key)) changed = true;
      });
      this.SaveColumns();
      if (changed) this.Search();
    },
    // Серверга фақат тўлдирилган филтрлар юборилади —
    // бўш филтрлар юборилса натижа қайтмайди
    BuildPayload() {
      var payload = {
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        totalRows: this.filter.totalRows,
      };
      var filters = {};
      var hasFilter = false;
      Object.keys(this.filter.filters).forEach((key) => {
        var item = this.filter.filters[key];
        if (item.value === "" || item.value == null) return;
        filters[key] = { value: item.value, matchmode: item.matchmode };
        hasFilter = true;
      });
      if (hasFilter) payload.filters = filters;
      return payload;
    },
    Refresh() {
      var payload = this.BuildPayload();
      // Ходим (isEmployee) учун алоҳида инспектор API'си ишлатилади
      var request = this.IsEmployee
        ? RequestService.GetListInspector(payload)
        : RequestService.GetList(payload);
      request
        .then((res) => {
          this.Requests = res.data.rows || [];
          this.filter.totalRows = res.data.total || 0;
        })
        .catch((error) => {
          this.Loading = false;
          this.$message(error.response.data);
        });
    },
    // Ходим учун инспектор ҳолати кўрсатилади (BO'даги statusSort каби)
    StatusText(item) {
      return item.inspectorStatus || item.status;
    },
    StatusVariant(item) {
      var id =
        item.inspectorStatusId != null ? item.inspectorStatusId : item.statusId;
      return StatusVariants[id] || "secondary";
    },
    GetComplaint(item) {
      this.$router.push({ name: "EditComplaint", params: { id: item.id } });
    },
    Get(item) {
      if (!item || !item.id) return;
      this.$router.push({ name: "RequestView", params: { id: item.id } });
    },
    GetIBContractor(item) {
      this.$router.push({
        name: "InspectionBookOfContractorEdit",
        params: { id: item.id },
        query: { fromRequest: true },
      });
    },
    GetIB(item) {
      this.$router.push({
        name: "InspectionBookEdit",
        params: { id: item.id },
        query: { fromRequest: true },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.rq-table {
  font-size: 13px;
}

.rq-filter-row {
  background: #f7f9ff;

  td {
    padding: 6px;
  }

  .form-control {
    min-width: 120px;
    font-size: 12px;
    border-radius: 8px;
  }
}

.rq-filter-actions {
  display: flex;
  gap: 4px;
  justify-content: center;
  white-space: nowrap;
}

.rq-badge {
  padding: 5px 10px;
  font-size: 10px;
  text-transform: uppercase;
  white-space: normal;
}

.rq-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: $primary;
  background: #eaf2ff;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;

  &:hover {
    background: $primary;
    color: #fff;
  }
}
</style>

<!-- Dropdown menu'ни BDropdown ўзи render қилади — scoped стил унга тегмайди -->
<style lang="scss">
.rq-columns-menu {
  max-height: 400px;
  min-width: 260px;
  overflow-y: auto;

  .dropdown-item {
    display: flex;
    align-items: center;
    white-space: normal;
    cursor: pointer;
  }
}
</style>
